import Label from "./Label"
import classNames from "classnames"

export default function ControlContainer({
  name,
  kind,
  label,
  description,
  errorCondition,
  error,
  hideError = false,
  hideLabel = false,
  className,
  children,
}) {
  return (
    <div className={classNames("w-full", className)}>
      {!hideLabel && (
        <Label kind={kind} label={label} description={description} />
      )}
      {children}
      {errorCondition && !hideError && (
        <div
          data-testid={`form-input-error-${name}`}
          className="text-sm italic text-red-500"
        >
          {error}
        </div>
      )}
    </div>
  )
}
